export default function (input) {
	// Checked as soon as the CV is chosen, with the browser's own validation message: past PHP's limits, a big PDF never reaches Laravel's message and gets an error page instead of the form.
	input.addEventListener('change', () => {
		const tooBig = [...input.files].some((file) => file.size > Number(input.dataset.maxSize));

		input.setCustomValidity(tooBig ? input.dataset.sizeError : '');
		input.reportValidity();
	});
}
